<template>
  <b-modal
    id="modalCidadao"
    size="xl"
    hide-footer
    centered
    :no-enforce-focus="true"
    dialog-class="consulta-modal-dialog"
    content-class="consulta-modal-content"
  >
    <b-container fluid class="dashboard">
      <b-row>
        <b-col cols="12" md="12">
          <!-- Header do cidadão -->
          <InfoCidadao
            :cidadao="cidadao"
            :activeKey="activeKey"
            @update-filtro-atendimento="atualizarFiltro"
          />
        </b-col>
      </b-row>
      <b-row>
        <!-- Desktop Sidebar -->
        <b-col cols="12" md="3" sm="12" class="sidebar-col">
          <aside class="sidebar">
            <SidebarMenu
              :menu="menu"
              :activeKey="activeKey"
              @select="activeKey = $event"
              :cidadao="cidadao"
            />
          </aside>
        </b-col>

        <!-- CONTEÚDO -->
        <b-col cols="12" md="9" sm="12" class="content">
          <div v-if="cidadao != null">
            <!-- Título da aba + Pesquisar -->
            <div class="d-flex align-items-center justify-content-between mb-3">
              <div class="d-flex align-items-center title-page">
                <i
                  v-if="iconeAba"
                  :class="['icofont', iconeAba, 'mr-2']"
                  aria-hidden="true"
                ></i>
                <h5 class="mb-0">{{ tituloAba }}</h5>
              </div>
              <div class="d-flex align-items-center" style="gap: 10px">
                <!-- Botão PDF -->
                <button
                  v-if="activeKey === 'pendencias'"
                  class="btn"
                  @click="downloadPendencias()"
                >
                  PDF
                </button>
                <!-- Botão SQL -->
                <button
                  v-if="
                    $store.state.id_funcao == 2 &&
                    activeKey !== 'pendencias' &&
                    activeKey !== 'mais-indicadores' &&
                    this.$store.state.cod_ibge != 1111111
                  "
                  class="btn"
                  @click="showSql = true"
                  style="text-transform: initial"
                >
                  SQL
                </button>
                <!-- Botão Reprocessamento -->
                <button
                  v-if="
                    activeKey === 'historico' ||
                    activeKey === 'atendimentos' ||
                    activeKey === 'odonto' ||
                    activeKey === 'procedimentos' ||
                    activeKey === 'visitas'
                  "
                  class="btn"
                  :disabled="loadingReprocessamento"
                  @click="showReprocessamento = true"
                  style="text-transform: initial"
                >
                  Reprocessamento
                </button>
              </div>
            </div>

            <hr />

            <!-- Abas / Conteúdo - repassa o objeto para as páginas -->
            <PendenciasCriticas
              ref="pendencias"
              v-if="activeKey === 'pendencias'"
              :cidadao="cidadao"
            />
            <HistoricoCadastral
              ref="historico"
              v-else-if="activeKey === 'historico'"
              :cidadao="cidadao"
              :filtroAtendimento="filtroAt"
            />
            <Duplicados
              ref="duplicados"
              v-else-if="activeKey === 'duplicados'"
              :cidadao="cidadao"
              :filtroAtendimento="filtroAt"
            />
            <Unificacoes
              ref="unificacoes"
              v-else-if="activeKey === 'unificacoes'"
              :cidadao="cidadao"
              :filtroAtendimento="filtroAt"
            />
            <Atendimentos
              ref="atendimentos"
              v-else-if="activeKey === 'atendimentos'"
              :cidadao="cidadao"
              :filtroAtendimento="filtroAt"
              :cnsList="cnsList"
            />
            <Odonto
              ref="odonto"
              v-else-if="activeKey === 'odonto'"
              :cidadao="cidadao"
              :filtroAtendimento="filtroAt"
              :cnsList="cnsList"
            />
            <Vacinas
              ref="vacinas"
              v-else-if="activeKey === 'vacinas'"
              :cidadao="cidadao"
              :filtroAtendimento="filtroAt"
              :cnsList="cnsList"
            />
            <Procedimentos
              ref="procedimentos"
              v-else-if="activeKey === 'procedimentos'"
              :cidadao="cidadao"
              :filtroAtendimento="filtroAt"
              :cnsList="cnsList"
            />
            <Visitas
              v-else-if="activeKey === 'visitas'"
              ref="visitas"
              :cidadao="cidadao"
              :filtroAtendimento="filtroAt"
              :cnsList="cnsList"
            />
            <Problemas
              v-else-if="activeKey === 'problemas'"
              ref="problemas"
              :cidadao="cidadao"
              :filtroAtendimento="filtroAt"
              :cnsList="cnsList"
            />
            <Exames
              v-else-if="activeKey === 'exames'"
              ref="exames"
              :cidadao="cidadao"
              :filtroAtendimento="filtroAt"
              :cnsList="cnsList"
            />
            <MaisIndicadores
              v-else-if="activeKey === 'mais-indicadores'"
              ref="mais-indicadores"
              :cidadao="cidadao"
              :filtroAtendimento="filtroAt"
              :cnsList="cnsList"
            />
          </div>
        </b-col>
      </b-row>
    </b-container>

    <ReprocessamentoModal
      :show.sync="showReprocessamento"
      :loading="loadingReprocessamento"
      @salvar="reprocessamento"
    />

    <SqlModal
      :canDownload="true"
      :show.sync="showSql"
      :activeKey="activeKey"
      :cidadao="cidadao"
      :cnsList="cnsList"
    />
  </b-modal>
</template>

<script>
import InfoCidadao from './InfoCidadao.vue'
import PendenciasCriticas from '../views/PendenciasCriticas.vue'
import HistoricoCadastral from '../views/HistoricoCadastral.vue'
import Duplicados from '../views/Duplicados.vue'
import Unificacoes from '../views/Unificacoes.vue'
import Atendimentos from '../views/Atendimentos.vue'
import Odonto from '../views/Odonto.vue'
import Vacinas from '../views/Vacinas.vue'
import Procedimentos from '../views/Procedimentos.vue'
import Visitas from '../views/Visitas.vue'
import Problemas from '../views/Problemas.vue'
import Exames from '../views/Exames.vue'
import MaisIndicadores from '../views/MaisIndicadores.vue'
import utils from '@/mixins/utils.js'
import SidebarMenu from '../components/SidebarMenu.vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import ReprocessamentoModal from './ReprocessamentoModal.vue'
import SqlModal from './SqlModal.vue'

export default {
  name: 'ModalCidadao',
  components: {
    InfoCidadao,
    PendenciasCriticas,
    HistoricoCadastral,
    Duplicados,
    Unificacoes,
    Atendimentos,
    Odonto,
    Vacinas,
    Procedimentos,
    Visitas,
    Problemas,
    Exames,
    MaisIndicadores,
    SidebarMenu,
    ReprocessamentoModal,
    SqlModal,
  },
  props: {
    cidadao: {
      type: Object,
      default: () => null,
    },
    cnsList: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [utils],
  data() {
    return {
      activeKey: 'historico',
      menu: [
        {
          key: 'historico',
          label: 'Histórico Cadastral',
          leftIcon: 'icofont-history',
        },
        {
          key: 'duplicados',
          label: 'Duplicados',
          leftIcon: 'icofont-copy',
        },
        {
          key: 'unificacoes',
          label: 'Unificações',
          leftIcon: 'icofont-link',
        },
        {
          key: 'atendimentos',
          label: 'Atendimentos',
          leftIcon: 'icofont-ui-chat',
        },
        {
          key: 'odonto',
          label: 'Odonto',
          leftIcon: 'icofont-tooth',
        },
        {
          key: 'vacinas',
          label: 'Vacinas',
          leftIcon: 'icofont-injection-syringe',
        },
        {
          key: 'procedimentos',
          label: 'Procedimentos',
          leftIcon: 'icofont-file-alt',
        },
        {
          key: 'visitas',
          label: 'Visitas',
          leftIcon: 'icofont-home',
        },
        {
          key: 'problemas',
          label: 'Problemas',
          leftIcon: 'icofont-error',
        },
        {
          key: 'exames',
          label: 'Exames',
          leftIcon: 'icofont-copy',
        },
        {
          key: 'pendencias',
          label: 'Pendências Críticas',
          leftIcon: 'icofont-warning-alt',
        },
        {
          key: 'mais-indicadores',
          label: 'Mais indicadores',
          leftIcon: 'icofont-checked',
        },
      ],
      filtroAt: { filtro: null, operador: '>=', data: '' },
      showReprocessamento: false,
      loadingReprocessamento: false,
      showSql: false,
    }
  },
  computed: {
    tituloAba() {
      const m = this.menu.find((i) => i.key === this.activeKey)
      return m ? m.label : ''
    },
    iconeAba() {
      const m = this.menu.find((i) => i.key === this.activeKey)
      return m ? m.leftIcon : null
    },
  },
  watch: {
    cidadao: {
      immediate: true,
      deep: true,
      handler(novo) {
        if (!novo) return
        const { total } = this.contarPendenciasAtivas(novo.pendencias_criticas)
        this.atualizarBadgePendencias(total)
      },
    },
  },
  mounted() {},
  methods: {
    /**
     * Conta as pendências críticas ativas e retorna suas chaves.
     * @param {Object} pendencias Lista de pendências do cidadão
     * @returns {Object} Total e chaves das pendências ativas
     */
    contarPendenciasAtivas(pendencias) {
      if (!pendencias) {
        return { total: 0, chaves: [] }
      }

      let total = 0
      let chaves = []

      Object.keys(pendencias).forEach((k) => {
        const v = pendencias[k]

        if (v == null) return

        // Caso específico para a pendencia 8
        if (k == 'pendencia_8' && Array.isArray(v)) {
          if (v.length > 0) {
            v.forEach((el) => {
              if (el.pendencias.length > 0) {
                total += 1
              }
            })
            chaves.push(k)
          }
          return
        }

        // Se for objeto com active
        if (typeof v === 'object') {
          if (v.active === true) {
            total += 1
            chaves.push(k)
          }
          return
        }

        // boolean simples
        if (v === true) {
          total += 1
          chaves.push(k)
        }
      })

      return { total, chaves }
    },

    /**
     * Atualiza o badge do menu de pendências.
     * @param {Number} total Quantidade de pendências ativas
     */
    atualizarBadgePendencias(total) {
      const idx = this.menu.findIndex((i) => i.key === 'pendencias')
      if (idx === -1) return
      const badgeValue = total > 0 ? total : null
      const badgeColor =
        total > 0 ? '#e03131' /* vermelho */ : '#28a745' /* verde */

      this.$set(this.menu[idx], 'badge', badgeValue)
      this.$set(this.menu[idx], 'badgeColor', badgeColor)
      this.$set(this.menu[idx], 'badgeTextColor', '#fff')
    },

    /**
     * Atualiza o filtro de atendimento selecionado.
     * @param {Object} payload Dados do filtro
     */
    atualizarFiltro(payload) {
      this.filtroAt = payload
    },

    /**
     * Realiza o reprocessamento dos dados
     * @param {String} dataReprocessamento
     */
    async reprocessamento(dataReprocessamento) {
      this.loadingReprocessamento = true

      try {
        const response = await this.$api.post('/app/cidadao/reprocessamento', {
          co_ibge: this.$store.state.cod_ibge,
          date: dataReprocessamento,
          key: this.activeKey,
        })

        if (response.data.error == false) {
          this.$toast.success(response.data.message, 'Sucesso:', {
            position: 'topRight',
          })
        } else {
          this.$toast.error(response.data.message, 'Erro:', {
            position: 'topRight',
          })
        }
      } catch (e) {
        console.error(e)
        this.$toast.error(
          'Ocorreu um erro ao processar o Reprocessamento.',
          'Erro:',
          {
            position: 'topRight',
          }
        )
      } finally {
        this.loadingReprocessamento = false
      }
    },

    /**
     * Gera o relatório em PDF das pendências
     */
    downloadPendencias() {
      const titlePdf = 'Pendências críticas'
      const titlePdfSave = this.titlePdf(titlePdf)
      const descriptionPdf = ''
      const headersPdf = ['Pendências']

      const dataPdf = []

      const add = (key, msg) => {
        if (msg) {
          dataPdf.push({
            key: msg,
          })
        }
      }

      const pendencias = this.cidadao.pendencias_criticas

      if (pendencias.pendencia_1 === true) {
        add(
          'pendencia_1',
          'Recomenda-se entrar em contato com nosso suporte e pedir para atualizar a Sincronização.'
        )
      }

      if (pendencias.pendencia_2 === true) {
        add(
          'pendencia_2',
          'Pessoa com acompanhamento recente. Recomenda-se atualizar o cadastro individual.'
        )
      }

      if (pendencias.pendencia_3 === true) {
        add(
          'pendencia_3',
          'Cadastro atualizado há mais de 2 anos. Recomenda-se atualizar o cadastro individual.'
        )
      }

      if (pendencias.pendencia_4 === true) {
        add(
          'pendencia_4',
          'Pessoa com mais de um cadastro/prontuário. Recomenda-se fazer a unificação no PEC ou Centralizador.'
        )
      }

      if (pendencias.pendencia_5 === true) {
        add(
          'pendencia_5',
          'Atualizar o cadastro individual vinculando a uma equipe (eSF, eSFR ou eAP).'
        )
      }

      if (pendencias.pendencia_6 === true) {
        add(
          'pendencia_6',
          'Pessoa com mais de um cadastro/prontuário. Recomenda-se fazer a unificação no PEC ou Centralizador.'
        )
      }

      if (pendencias.pendencia_7 && pendencias.pendencia_7.active === true) {
        add('pendencia_7', pendencias.pendencia_7.text)
      }

      if (pendencias.pendencia_8.length > 0) {
        pendencias.pendencia_8.forEach((el) => {
          if (el.pendencias.length > 0) {
            el.pendencias.forEach((el2, index) => {
              add(`pendencia_8_${index}`, el2)
            })
          }
        })
      }

      const doc = new jsPDF(this.encryptionPdf())
      const table = this.createTablePdf(dataPdf)

      this.fileToBase64(this.$store.state.infoMunicipio.brasao)
        .then((base64Brasao) => {
          let verticalPosition = this.headerPdf(
            doc,
            base64Brasao,
            titlePdf,
            descriptionPdf
          )

          const equipeInfo = [
            {
              label: 'Cidadão(ã)',
              value: this.cidadao.no_cidadao,
            },
            {
              label: 'Sexo',
              value: this.cidadao.sexo,
            },
            { label: 'CPF', value: this.cidadao.nu_cpf },
          ]

          verticalPosition = this.bodyPdf(doc, equipeInfo, verticalPosition)

          doc.autoTable({
            head: [headersPdf],
            body: table,
            headStyles: {
              fillColor: '#ccc',
              fontSize: 12,
              textColor: '#000',
              halign: 'center',
              cellWidth: 'wrap',
            },
            bodyStyles: {
              halign: 'center',
              fontSize: 10,
            },
            theme: 'striped',
            startY: verticalPosition,
            showHead: 'firstPage',
          })

          this.footerPdf(doc, doc.autoTable.previous.finalY)
          doc.save(`${titlePdfSave}.pdf`)

          this.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
            position: 'topRight',
          })
        })
        .catch((error) => {
          console.error(error)
          this.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
            position: 'topRight',
          })
        })
    },
  },
}
</script>

<style scoped lang="scss">
.content {
  padding: 20px 24px;
}

.title-page {
  font-size: 22px;
  font-weight: 700;
  h5,
  i {
    font-weight: 700;
  }
}

.spinner-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
}
</style>

<style>
.consulta-modal-dialog {
  max-width: 85vw !important;
  width: 85vw;
}
</style>
